import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'POST_SEND_COMMUNICATION';

export const resetSendCommunicationApi = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = useAction(() => {
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
    };
  });
  return [result, action];
};

const convertToJson = (res, args) => {
  event('API_TRANSACTION', {
    fields: {
      appVersion: process.env.PACKAGE_VERSION,
      url: window.location.href,
      endpoint: config('COMMUNICATION_URL'),
      userInfo: args?.userInfo,
      method: 'POST',
      code: res.status,
      operationName: ACTION_TYPE,
      message: res.statusText,
      result: res.status === 200 ? 'success' : 'error',
    },
  });
  return new Promise((resolve) => {
    return res.json().then((response) => {
      return resolve({
        status: res.status,
        response,
      });
    });
  });
};

const getAction = () => {
  const action = useAction((args) => {
    const eapm = window.elasticApm;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: true,
      });
    }

    const { variables = {} } = args;
    const { request, files } = variables;
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
      dispatch({ type: `${ACTION_TYPE}_CALLED` });

      const formData = new FormData();
      formData.append('communicationsCornerRequest', JSON.stringify(request));
      if (files && files.length > 0) {
        files.forEach((file, index) => {
          formData.append(`file${index + 1}`, file);
        });
      }

      fetch(
        `${config('APIM_STARGATE_URL')}${config(
          'COMMUNICATION_URL'
        )}/attachment/upload/v1.0`,
        {
          credentials: 'include',
          method: 'post',
          body: formData,
        }
      )
        .then((res) => {
          return convertToJson(res, args);
        })
        .then((res) => {
          if (res.status !== 200) {
            if (res.status === 500) {
              throw new Error(
                'Your request was unsuccessful, please try again.'
              );
            } else {
              dispatch({
                type: `${ACTION_TYPE}_ERROR`,
                payload: res.response,
              });
            }
          } else {
            dispatch({
              type: `${ACTION_TYPE}_COMPLETED`,
              payload: res.response,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });

          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('COMMUNICATION_URL'),
              userInfo: args?.userInfo,
              method: 'POST',
              operationName: ACTION_TYPE,
            },
          });
        });
    };
  });
  return action;
};
export const useSendCommunicationApi = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = getAction();

  return [result, action];
};
